import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=4a061ef0&scoped=true"
import script from "./customPage.vue?vue&type=script&lang=js"
export * from "./customPage.vue?vue&type=script&lang=js"
import style0 from "./customPage.vue?vue&type=style&index=0&id=4a061ef0&prod&scoped=true&lang=css"
import style1 from "./customPage.vue?vue&type=style&index=1&id=4a061ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a061ef0",
  null
  
)

export default component.exports